import React from 'react';
import { TIMEZONE_OPTIONS, getTimezoneOptionsByRegion } from '../../utils/timezone';

export default function TimezoneSelector({ value, onChange, className = "" }) {
  const groupedTimezones = getTimezoneOptionsByRegion();
  const regionOrder = ['Asia-Pacific', 'Europe', 'Americas', 'Africa'];

  return (
    <select
      value={value || 'Asia/Singapore'}
      onChange={(e) => onChange(e.target.value)}
      className={`w-full border rounded px-2 py-1 ${className}`}
    >
      {regionOrder.map(region => (
        groupedTimezones[region] && (
          <optgroup key={region} label={region}>
            {groupedTimezones[region].map(tz => (
              <option key={tz.value} value={tz.value}>
                {tz.label}
              </option>
            ))}
          </optgroup>
        )
      ))}
    </select>
  );
}
